import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Facebook,
  Instagram,
  Tv,
  // Twitter,
  Globe,
  Play,
  ArrowRight,
  Zap,
  BarChart3,
  PauseIcon,
  PlayIcon,
  Building,
  AudioWaveform,
  HeadphonesIcon,
} from "lucide-react";
import BackToTop from "../components/BackToTop/BackToTop";
import TestimonialCarousel, { testimonials } from "../components/TestimonialCarousel";
import Footer from "../components/Footer";
import Header from "../components/Header";

export default function Home() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(true);
  const [progress, setProgress] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  // Hide controls after 1 sec when playing
  useEffect(() => {
    let timeout;

    if (isPlaying) {
      timeout = setTimeout(() => {
        setShowControls(false);
      }, 1000);
    }

    return () => clearTimeout(timeout);
  }, [isPlaying]);

  const handleToggle = () => {
    if (!videoRef.current) return;

    if (isPlaying) {
      videoRef.current.pause();
      setShowControls(true);
    } else {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
      setShowControls(true);
    }

    setIsPlaying(!isPlaying);
  };

  const handleMouseMove = () => {
    if (isPlaying) setShowControls(true);
  };

  const handleMouseLeave = () => {
    if (isPlaying) setShowControls(false);
  };


  const handleTimeUpdate = () => {
    if (videoRef.current) {
      const progress = (videoRef.current.currentTime / videoRef.current.duration) * 100;
      setProgress(progress);
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const handleSeek = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const width = rect.width;
    const percentage = x / width;
    const newTime = percentage * videoRef.current.duration;

    if (videoRef.current) {
      videoRef.current.currentTime = newTime;
      setProgress(percentage * 100);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <BackToTop />

      {/* ================= HEADER ================= */}
      <Header />


      {/* ================= HERO ================= */}
      <div className="relative min-h-[calc(100vh-81px)] bg-gradient-to-br from-slate-50 via-white to-indigo-50 overflow-hidden">

        {/* <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,rgba(99,102,241,0.18),transparent_45%),radial-gradient(circle_at_80%_70%,rgba(168,85,247,0.18),transparent_45%)]" /> */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_25%,rgba(99,102,241,0.12),transparent_40%),radial-gradient(circle_at_85%_75%,rgba(168,85,247,0.12),transparent_40%)]" />

        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-10 w-96 h-96 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-float"></div>
          <div className="absolute top-40 right-10 w-96 h-96 bg-yellow-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-float animation-delay-2000"></div>
          <div className="absolute bottom-20 left-1/3 w-96 h-96 bg-pink-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-float animation-delay-4000"></div>

          {/* Moving particles */}
          <div className="absolute inset-0">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className="absolute w-1 h-1 bg-indigo-300 rounded-full animate-particle"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 5}s`,
                  animationDuration: `${10 + Math.random() * 10}s`
                }}
              />
            ))}
          </div>
        </div>

        <main className="relative text-center px-6 py-16 sm:py-20 md:py-24 lg:py-28  max-w-5xl mx-auto">

          {/* <div className="inline-flex items-center gap-2 bg-black text-white text-sm px-4 py-1 rounded-full mb-6 shadow">
              <span className="font-semibold">New</span>
              <span>CTV Launchpad is here</span>
            </div> */}

          <div className="flex justify-center mb-8">
            <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full border border-gray-200 shadow-sm hover:border-indigo-200 hover:shadow-md transition-all duration-300">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
              </span>
              <span className="text-sm font-medium text-gray-700">New: CTV Launchpad is here</span>
              <span className="bg-indigo-50 text-indigo-600 text-xs px-2 py-0.5 rounded-full font-medium">Live now</span>
            </div>
          </div>

          {/* <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
              Transform Your Social Media Posts into
              <span className="block text-black">
                Stunning 4K TV Ads
              </span>
            </h1> */}

          <h1 className="text-4xl md:text-6xl font-bold  mb-6">
            Transform Your Social Media Posts into
            <span className="block -mt-2 leading-tight bg-gradient-to-r  from-indigo-600 to-purple-600 bg-clip-text text-transparent">
              Stunning TV Ads
            </span>
          </h1>


          {/* <p className="text-gray-600 text-lg max-w-3xl mx-auto mb-10">
          Unlock your social content from Instagram, TikTok, Facebook, X, and Pinterest
          with an easy platform that creates beautiful CTV ads audiences love.
        </p> */}

          <p className="text-gray-600 text-lg md:text-xl max-w-3xl mx-auto text-center mb-12 leading-relaxed">
            Unlock your social content from{" "}
            <span className="font-semibold text-black ">
              Instagram, TikTok, and Facebook
            </span>{" "}
            with our AI-powered platform that creates stunning CTV experiences in minutes.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-16 z-10">
            <Link
              to="/dashboard/editor"
              className="flex items-center gap-2  bg-black text-white px-8 py-3 rounded-xl overflow-hidden hover:scale-105 transition-transform shadow-lg relative group"
            >
              <span className="relative z-10 flex items-center gap-3 text-lg">
                <span>Start Creating Free</span>
                <ArrowRight className="h-5 w-5 group-hover:translate-x-2 transition-transform" />
              </span>
              <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
            </Link>
            <Link
              to="/templates"
              className="group inline-flex items-center justify-center gap-2 bg-white border-2 border-gray-200 text-gray-700 px-8 py-3 rounded-xl hover:border-indigo-300 hover:bg-indigo-50/30 transition-all duration-300 shadow-lg hover:shadow-xl font-medium text-lg"
            >
              <Play size={16} />
              <span>Watch Demo</span>
            </Link>
          </div>

          {/* ================= SOCIAL ROW ================= */}
          <div className="flex justify-center gap-8 flex-wrap">
            <SocialItem icon={<Instagram />} label="Instagram" color="from-pink-500 to-purple-600" />
            <SocialItem icon={<TikTokIcon />} label="Tiktok" color="bg-gradient-to-r from-[#25F4EE] to-[#FE2C55]" />
            <SocialItem icon={<Facebook />} label="Facebook" color="from-blue-600 to-blue-700" />
            {/* <SocialItem icon={<Twitter />} label="X (Twitter)" color="from-gray-900 to-black" /> */}
            {/* <SocialItem
              icon={
                <svg className="h-6 w-6 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0a12 12 0 0 0-4.37 23.17c-.1-.94-.2-2.4 0-3.44.2-.94 1.27-5.36 1.27-5.36a3.68 3.68 0 0 1-.3-1.52c0-1.42.83-2.48 1.86-2.48.88 0 1.3.66 1.3 1.45 0 .88-.56 2.2-.86 3.42a1.5 1.5 0 0 0 1.53 1.87c1.84 0 3.25-1.94 3.25-4.73 0-2.47-1.78-4.2-4.32-4.2a4.47 4.47 0 0 0-4.67 4.47 4 4 0 0 0 .76 2.35.31.31 0 0 1 .07.3c-.08.3-.25.97-.28 1.1-.05.18-.16.22-.36.13-1.34-.62-2.18-2.56-2.18-4.12 0-3.36 2.44-6.44 7.03-6.44 3.7 0 6.56 2.63 6.56 6.14 0 3.67-2.31 6.62-5.52 6.62a2.85 2.85 0 0 1-2.42-1.22l-.66 2.5a10.62 10.62 0 0 1-1.04 2.2A12 12 0 1 0 12 0z" />
                </svg>
              }
              label="Pinterest"
              color="from-red-600 to-red-500"
            /> */}
          </div>
        </main >
      </div>


      {/* ================= CTV IMAGE SHOWCASE ================= */}
      <section className="py-16 sm:py-20 md:py-24 lg:py-28  bg-white" >
        <div className="max-w-7xl mx-auto px-6 text-center">

          {/* <h2 className="text-4xl font-bold mb-6">
            See SocialTV in Action
          </h2>

          <p className="text-gray-600 mb-14 max-w-2xl mx-auto">
            Your social content beautifully transformed into a premium Connected TV experience.
          </p> */}

          {/* Title with Gradient */}
          {/* <h2 className="text-4xl md:text-5xl font-bold mb-4">
              See{" "}
              <span className="relative inline-block">
                <span className="bg-gradient-to-r from-black via-gray-800 to-gray-600 bg-clip-text text-transparent">
                  SocialTV
                </span>
                <div className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-transparent via-black to-transparent rounded-full"></div>
              </span>
              {" "}in{" "}
              <span className="text-black relative">
                Action
              </span>
            </h2>

            <p className="text-gray-600 max-w-2xl mx-auto text-lg mb-8 animate-fade-in">
              Your social content beautifully transformed into a premium Connected TV experience.
            </p> */}

          <div className="text-center max-w-3xl mx-auto mb-16">

            {/* Modern pill badge */}
            <div className="inline-flex items-center gap-2 bg-white border border-gray-200 px-4 py-2 rounded-full mb-6 shadow-sm">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500"></span>
              </span>
              <span className="text-sm font-medium text-gray-600">Live Demo</span>
            </div>

            {/* Modern title with gradient */}
            <h2 className="text-4xl md:text-5xl font-bold  leading-snug mb-6">
              <span className="text-gray-900">See</span>
              <span className="relative inline-block mx-3">
                <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                  SocialTV
                </span>
                <span className="absolute -bottom-1 left-0 w-full h-1 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 rounded-full"></span>
              </span>
              <span className="text-gray-900">in Action</span>
            </h2>

            {/* Clean description */}
            <p className="text-xl text-gray-500 max-w-2xl mx-auto leading-relaxed">
              Watch how your social content transforms into a stunning Connected TV experience in real-time.
            </p>
          </div>

          {/* Feature Tags */}
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-blue-100 text-blue-600 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 cursor-default">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              <span className="text-sm font-medium">4K Resolution</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-yellow-100 text-yellow-600 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 cursor-default">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              <span className="text-sm font-medium">AI Enhanced</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-purple-100 text-purple-600 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 cursor-default">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
              </svg>
              <span className="text-sm font-medium">Multi-Platform</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-green-100 text-green-600 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 cursor-default">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-sm font-medium">Real-time</span>
            </div>
          </div>

          <div className="max-w-6xl mx-auto">
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">

              {/* Card header */}
              <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="flex gap-1.5">
                    <div className="w-2.5 h-2.5 bg-red-400 rounded-full"></div>
                    <div className="w-2.5 h-2.5 bg-yellow-400 rounded-full"></div>
                    <div className="w-2.5 h-2.5 bg-green-400 rounded-full"></div>
                  </div>
                  <span className="text-sm text-gray-400 ml-2">Preview</span>
                </div>
                <span className="text-xs px-2 py-1 bg-indigo-50 text-indigo-600 rounded-full">4K • HDR</span>
              </div>

              <div
                className="relative aspect-video overflow-hidden"
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
              >
                {/* Play / Pause Button */}
                {showControls && (
                  <div className="absolute inset-0 flex items-center justify-center z-10">
                    <button
                      onClick={handleToggle}
                      className="bg-black/60 backdrop-blur-sm text-white rounded-full h-[60px] w-[60px] flex items-center justify-center hover:scale-110 transition duration-300"
                    >
                      {isPlaying ? (
                        <PauseIcon className="w-6 h-6" />
                      ) : (
                        <PlayIcon className="w-6 h-6 ml-1" />
                      )}
                    </button>
                  </div>
                )}

                {/* Video */}
                <video
                  ref={videoRef}
                  src="https://test-pages.b-cdn.net/SocialTV/Master/layout3.mp4"
                  className="w-full h-full object-cover"
                  playsInline
                  preload="metadata"
                  onClick={handleToggle}
                  onTimeUpdate={handleTimeUpdate}
                  onLoadedMetadata={(e) => {
                    if (e.target) {
                      e.target.currentTime = 4;
                      setDuration(e.target.currentTime);
                    }
                  }}
                  onEnded={() => {
                    setIsPlaying(false);
                    setShowControls(true);
                  }}
                  onMouseEnter={() => setShowControls(true)}
                  onMouseLeave={() => setShowControls(false)}
                />

                {/* Modern progress bar */}
                <div className="absolute bottom-0 left-0 right-0 z-20">
                  {/* Time indicators */}
                  <div className="flex justify-between px-4 mb-1 text-xs text-white/80">
                    <span>{formatTime(currentTime)}</span>
                    <span>{formatTime(duration)}</span>
                  </div>

                  {/* Progress bar with seek */}
                  <div
                    className="h-1.5 bg-white/30 cursor-pointer group/progress"
                    onClick={handleSeek}
                  >
                    <div
                      className="h-full bg-gradient-to-r from-indigo-500 to-purple-500 relative"
                      style={{ width: `${progress}%` }}
                    >
                      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-3 h-3 bg-white rounded-full shadow-lg opacity-0 group-hover/progress:opacity-100 transition-opacity"></div>
                    </div>
                  </div>
                </div>

                {/* Bottom fade */}
                <div className="absolute bottom-0 left-0 right-0 h-8 blur-md bg-gradient-to-t from-black/30 to-transparent pointer-events-none"></div>
              </div>

              {/* Card footer */}
              {/* <div className="px-6 py-4 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-gray-700">Instagram → CTV</span>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-gray-400">
                    <span className="w-1.5 h-1.5 bg-green-400 rounded-full"></span>
                    Live demo
                  </div>
                </div> */}

              <div className="bg-white px-6 py-4 border-b border-gray-100">
                <div className="flex items-center justify-between gap-4 flex-wrap">
                  <div className="flex items-center gap-3">
                    <div className="flex -space-x-3">
                      <div className="w-8 h-8 rounded-full bg-gradient-to-br from-pink-500 to-purple-600 border-2 border-white"></div>
                      <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-cyan-500 border-2 border-white"></div>
                      <div className="w-8 h-8 rounded-full bg-gradient-to-br from-gray-900 to-gray-700 border-2 border-white"></div>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-900">From Instagram to CTV</span>
                      <p className="text-xs text-gray-400">Transformed in 30 seconds</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-gray-400 flex items-center gap-1">
                      <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse"></span>
                      Live
                    </span>
                    <Link to={'/dashboard/editor'} className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 px-3 py-1.5 rounded-full transition-colors">
                      Try now →
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>


      {/* ================= WHY SECTION ================= */}
      <section className="py-16 sm:py-20 md:py-24 lg:py-28  bg-white relative overflow-hidden border-t border-b border-gray-100">
        {/* Animated Background Elements - More subtle and modern */}
        <div className="absolute inset-0 overflow-hidden">
          {/* Gradient orbs with modern colors */}
          <div className="absolute top-0 -left-40 w-[500px] h-[500px] bg-gradient-to-r from-indigo-200/20 via-purple-200/20 to-pink-200/20 rounded-full blur-3xl animate-float-slow"></div>
          <div className="absolute bottom-0 -right-40 w-[600px] h-[600px] bg-gradient-to-l from-blue-200/20 via-cyan-200/20 to-teal-200/20 rounded-full blur-3xl animate-float-slower"></div>


          {/* Floating particles - Minimal */}
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-gradient-to-r from-indigo-400 to-purple-400 rounded-full animate-float-particle"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 8}s`,
                animationDuration: `${15 + Math.random() * 15}s`,
                opacity: 0.2,
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto px-6 relative">
          {/* Section Header - Modern & Clean */}
          <div className="text-center max-w-3xl mx-auto mb-20">
            {/* Modern Animated Badge */}
            <div className="inline-flex items-center gap-2 bg-white border border-gray-200 px-4 py-2 rounded-full mb-8 shadow-sm hover:shadow-md hover:border-indigo-200 transition-all duration-300 group cursor-default">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500"></span>
              </span>
              <span className="text-sm font-medium text-gray-700 group-hover:text-indigo-600 transition-colors">
                Why Choose Us
              </span>
              {/* <span className="text-xs bg-indigo-50 text-indigo-600 px-2 py-0.5 rounded-full">New</span> */}
            </div>

            {/* Main Title - Clean & Bold */}
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6">
              <span className="text-gray-900">Why</span>
              <span className="relative inline-block mx-3">
                <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                  Social CTV
                </span>
                <span className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 rounded-full"></span>
              </span>
            </h2>

            <span className="block text-2xl md:text-3xl text-gray-600 font-normal mt-4">
              The smarter way to advertise on connected TV
            </span>

            {/* Subtitle */}
            <p className="text-xl text-gray-500 mt-2 mb-8 leading-relaxed">
              Transform your social media presence into premium TV experiences with our innovative platform
            </p>


            {/* Trust Indicators */}
            <div className="flex flex-wrap justify-center gap-6">
              {[
                { label: 'Enterprise-grade', icon: Building }, // building
                { label: '99.9% Uptime', icon: AudioWaveform }, // audio-waveform
                { label: '24/7 Support', icon: HeadphonesIcon }, // headphones
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-gray-500">
                  <span><item.icon /></span>
                  <span>{item.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Main Cards Grid - Modern Design */}
          <div className="grid md:grid-cols-3 gap-8 lg:gap-6 xl:gap-8 mb-24">
            {/* Card 1 - Reach Big Screens */}
            <div className="group relative bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 overflow-hidden border border-gray-100">
              {/* Gradient overlay on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600/5 via-indigo-600/5 to-purple-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              {/* Card content */}
              <div className="relative p-8">
                {/* Icon with animated background */}
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center text-white shadow-lg group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                    <Tv className="h-8 w-8" />
                  </div>
                  {/* Ripple effect */}
                  {/* <div className="absolute inset-0 rounded-2xl animate-ping-slow opacity-20 bg-blue-500"></div> */}
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                  Reach Big Screens
                </h3>

                {/* Description */}
                <p className="text-gray-500 mb-6 leading-relaxed">
                  Transform your social creatives into stunning TV ads that captivate audiences on the biggest screens.
                </p>

                {/* Stats badge */}
                <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 px-3 py-1.5 rounded-full text-sm font-medium mb-6">
                  <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                  2.5B+ Connected TVs
                </div>

                {/* Features list */}
                <ul className="space-y-3">
                  {[
                    '4K Ultra HD Quality',
                    'HDR10+ Support',
                    'Multi-Device Sync',
                    'Smart TV Optimized'
                  ].map((feature, i) => (
                    <li key={i} className="flex items-center gap-2 text-sm text-gray-600">
                      <svg className="w-4 h-4 text-blue-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>

                {/* Learn more link */}
                <div className="mt-8 pt-4 border-t border-gray-100">
                  <Link href="#" className="text-blue-600 font-medium inline-flex items-center gap-2 group/link">
                    Learn more
                    <svg className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>

            {/* Card 2 - Fast Production */}
            <div className="group relative bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 overflow-hidden border border-gray-100">
              <div className="absolute inset-0 bg-gradient-to-br from-orange-600/5 via-red-600/5 to-pink-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              <div className="relative p-8">
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center text-white shadow-lg group-hover:scale-110 group-hover:-rotate-3 transition-all duration-300">
                    <Zap className="h-8 w-8" />
                  </div>
                  {/* <div className="absolute inset-0 rounded-2xl animate-ping-slow opacity-20 bg-orange-500"></div> */}
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-orange-600 transition-colors">
                  Fast Production
                </h3>

                <p className="text-gray-500 mb-6 leading-relaxed">
                  Turn any social post into professional CTV ads in minutes, not days. AI handles the heavy lifting.
                </p>

                <div className="inline-flex items-center gap-2 bg-orange-50 text-orange-600 px-3 py-1.5 rounded-full text-sm font-medium mb-6">
                  <span className="w-1.5 h-1.5 bg-orange-600 rounded-full"></span>
                  85% Faster Production
                </div>

                <ul className="space-y-3">
                  {[
                    'AI-Powered Editing',
                    'Auto-Formatting',
                    'Batch Processing',
                    'Template Library'
                  ].map((feature, i) => (
                    <li key={i} className="flex items-center gap-2 text-sm text-gray-600">
                      <svg className="w-4 h-4 text-orange-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>

                <div className="mt-8 pt-4 border-t border-gray-100">
                  <Link href="#" className="text-orange-600 font-medium inline-flex items-center gap-2 group/link">
                    Learn more
                    <svg className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>

            {/* Card 3 - Measure Performance */}
            <div className="group relative bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 overflow-hidden border border-gray-100">
              <div className="absolute inset-0 bg-gradient-to-br from-green-600/5 via-emerald-600/5 to-teal-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              <div className="relative p-8">
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center text-white shadow-lg group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                    <BarChart3 className="h-8 w-8" />
                  </div>
                  {/* <div className="absolute inset-0 rounded-2xl animate-ping-slow opacity-20 bg-green-500"></div> */}
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-green-600 transition-colors">
                  Measure Performance
                </h3>

                <p className="text-gray-500 mb-6 leading-relaxed">
                  Track real-time views, engagement metrics, and ROI across all your CTV campaigns.
                </p>

                <div className="inline-flex items-center gap-2 bg-green-50 text-green-600 px-3 py-1.5 rounded-full text-sm font-medium mb-6">
                  <span className="w-1.5 h-1.5 bg-green-600 rounded-full animate-pulse"></span>
                  Real-time Analytics
                </div>

                <ul className="space-y-3">
                  {[
                    'Live Dashboard',
                    'Engagement Tracking',
                    'ROI Calculator',
                    'Audience Insights'
                  ].map((feature, i) => (
                    <li key={i} className="flex items-center gap-2 text-sm text-gray-600">
                      <svg className="w-4 h-4 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>

                <div className="mt-8 pt-4 border-t border-gray-100">
                  <Link href="#" className="text-green-600 font-medium inline-flex items-center gap-2 group/link">
                    Learn more
                    <svg className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Stats Grid - Modern Design */}
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <StatCard
                number="98%"
                label="Client Satisfaction"
                trend="12%"
                trendUp={true}
                color="blue"
              />
              <StatCard
                number="50M+"
                label="Ads Delivered"
                trend="25%"
                trendUp={true}
                color="orange"
              />
              <StatCard
                number="150+"
                label="Enterprise Clients"
                trend="30%"
                trendUp={true}
                color="green"
              />
              <StatCard
                number="24/7"
                label="Support Available"
                trend="Live"
                trendUp={true}
                color="purple"
              />
            </div>

            {/* Bottom CTA */}
            <div className="text-center mt-16">
              <Link
                to={`/dashboard/editor`}
                className="inline-flex items-center gap-3 bg-gray-900 text-white px-8 py-4 rounded-xl hover:bg-gray-800 transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 font-medium group"
              >
                <span>Start your free trial</span>
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section >


      {/* ================= HOW IT WORKS SECTION ================= */}
      <section className="py-16 sm:py-20 md:py-24 lg:py-28  bg-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_30%_30%,rgba(99,102,241,0.1),transparent_50%)]"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center max-w-3xl mx-auto mb-10">
            <div className="inline-flex items-center gap-2 bg-white border border-gray-200 px-4 py-2 rounded-full mb-8 shadow-sm hover:shadow-md hover:border-indigo-200 transition-all duration-300 group cursor-default">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500"></span>
              </span>
              <span className="text-sm font-medium text-gray-700 group-hover:text-indigo-600 transition-colors">
                Simple Process
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="text-gray-900">How It</span>
              <span className="relative inline-block mx-3">
                <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                  Works
                </span>
                <span className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full"></span>
              </span>
            </h2>

            <p className="text-xl text-gray-500 max-w-2xl mx-auto">
              Transform your social content into stunning CTV ads in just three simple steps
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
            {/* Step 1: Choose Template */}
            <div className="group relative">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-3xl opacity-0 group-hover:opacity-20 transition-opacity duration-500 blur-lg"></div>
              <div className="relative bg-white p-8 rounded-3xl border border-indigo-100 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
                <div className="flex items-center justify-between mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl flex items-center justify-center text-white text-2xl font-bold shadow-lg">
                    1
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Choose Template</h3>
                <p className="text-gray-500 mb-4">
                  Select from 50+ professional CTV ad templates. Each template is optimized for TV screens and VAST compatibility.
                </p>
                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="px-3 py-1 bg-indigo-50 text-indigo-600 text-xs rounded-full">Modern</span>
                  <span className="px-3 py-1 bg-purple-50 text-purple-600 text-xs rounded-full">Corporate</span>
                  <span className="px-3 py-1 bg-indigo-50 text-indigo-600 text-xs rounded-full">Dynamic</span>
                </div>
              </div>
            </div>

            {/* Step 2: Add Your Content & Video URL */}
            <div className="group relative">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-purple-500 to-pink-500 rounded-3xl opacity-0 group-hover:opacity-20 transition-opacity duration-500 blur-lg"></div>
              <div className="relative bg-white p-8 rounded-3xl border border-indigo-100 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
                <div className="flex items-center justify-between mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center text-white text-2xl font-bold shadow-lg">
                    2
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Add Your Content</h3>
                <p className="text-gray-500 mb-4">
                  Paste your video URL from YouTube, Vimeo, or social media. Add your brand logo and messaging to customize.
                </p>
                <div className="flex items-center gap-2 mt-4 text-sm text-purple-600">
                  <div>
                    <Zap className="h-4 w-4" />
                  </div>
                  <span>Auto 4K • HDR • 60fps</span>
                </div>
              </div>
            </div>

            {/* Step 3: Get VAST Tag */}
            <div className="group relative">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-pink-500 to-indigo-500 rounded-3xl opacity-0 group-hover:opacity-20 transition-opacity duration-500 blur-lg"></div>
              <div className="relative bg-white p-8 rounded-3xl border border-indigo-100 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
                <div className="flex items-center justify-between mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-indigo-600 rounded-2xl flex items-center justify-center text-white text-2xl font-bold shadow-lg">
                    3
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Get VAST Tag</h3>
                <p className="text-gray-500 mb-4">
                  Generate your VAST tag URL instantly. Copy and paste into any ad server or CTV platform.
                </p>
                <div className="flex items-center flex-wrap gap-2 mt-4">
                  <span className="px-3 py-1 bg-green-50 text-green-600 text-xs rounded-full">Ready in 30s</span>
                  <span className="px-3 py-1 bg-indigo-50 text-indigo-600 text-xs rounded-full">VAST 4.2</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>


      {/* ================= TESTIMONIALS SECTION ================= */}
      <section className="py-16 sm:py-20 md:py-24 lg:py-28   border-t border-slate-100 bg-white relative overflow-hidden">

        {/* Animated background elements */}
        <div className="absolute inset-0">
          <div className="absolute top-40 left-20 w-96 h-96 bg-indigo-200/30 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-40 right-20 w-96 h-96 bg-purple-200/30 rounded-full blur-3xl animate-pulse animation-delay-2000"></div>
        </div>

        <div className="absolute inset-0 overflow-hidden">
          {[...Array(30)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-gradient-to-r from-indigo-400 to-purple-400 rounded-full animate-float"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${15 + Math.random() * 15}s`,
                opacity: 0.2,
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
          {/* Section Header */}
          <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-10 md:mb-12 lg:mb-16">
            <div className="inline-flex items-center gap-2 bg-white border border-gray-200 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full mb-4 sm:mb-6 md:mb-8 shadow-sm hover:shadow-md hover:border-indigo-200 transition-all duration-300 group cursor-default">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500"></span>
              </span>
              <span className="text-xs sm:text-sm font-medium text-gray-700 group-hover:text-indigo-600 transition-colors">
                Testimonials
              </span>
            </div>

            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2 sm:mb-3 md:mb-4 px-2">
              <span className="text-gray-900">What Our</span>
              <span className="relative inline-block mx-1 sm:mx-2 md:mx-3">
                <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                  Creators
                </span>
                <span className="absolute -bottom-1 sm:-bottom-2 left-0 w-full h-0.5 sm:h-1 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full"></span>
              </span>
              <span className="text-gray-900">Say</span>
            </h2>

            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-500 max-w-2xl mx-auto px-4">
              Join thousands of marketers and creators who transform their social content into stunning CTV ads
            </p>
          </div>

          {/* Testimonial Carousel */}
          <TestimonialCarousel testimonials={testimonials} />
        </div>
      </section>


      {/* ================= TRUSTED SECTION ================= */}
      <section className="py-16 sm:py-20 bg-white border-t border-b border-slate-100" >
        <div className="max-w-6xl mx-auto px-6 text-center">

          <div className="flex items-center justify-center gap-2 mb-4">
            <Globe className="h-5 w-5 text-black" />
            <p className="text-xs tracking-[4px] font-semibold text-gray-500">
              TRUSTED BY TOP BRANDS AROUND THE WORLD
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 mt-10">
            <BrandPill name="Nike" />
            <BrandPill name="Meta" />
            <BrandPill name="Netflix" />
            <BrandPill name="Amazon" />
            <BrandPill name="Shopify" />
            <BrandPill name="Zara" />
          </div>
        </div>
      </section>


      {/* ================= FAQ SECTION ================= */}
      <section className="py-16 sm:py-20 md:py-24 lg:py-28  bg-white">
        <div className="max-w-5xl mx-auto px-6">
          {/* Section Header */}
          <div className="text-center max-w-3xl mx-auto mb-16">
            <div className="inline-flex items-center gap-2 bg-white border border-gray-200 px-4 py-2 rounded-full mb-8 shadow-sm">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500"></span>
              </span>
              <span className="text-sm font-medium text-gray-700">Got Questions?</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="text-gray-900">Frequently Asked</span>
              <span className="relative inline-block mx-3">
                <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                  Questions
                </span>
                <span className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full"></span>
              </span>
            </h2>
          </div>

          {/* FAQ Items */}
          <div className="space-y-4">
            {[
              {
                q: "What is a VAST tag and why do I need it?",
                a: "VAST (Video Ad Serving Template) is a universal format that allows video ads to be served across different platforms and devices. Your VAST tag is like a URL that tells ad servers where to find your video ad and how to display it. With SocialTV, we generate this automatically for you."
              },
              {
                q: "Can I use content from any social media platform?",
                a: "Yes! SocialTV supports imports from Instagram, TikTok, Facebook, X (Twitter), Pinterest, YouTube, and Vimeo. Simply paste the URL and our AI will optimize it for TV display."
              },
              {
                q: "How long does it take to create a CTV ad?",
                a: "Most users can create a professional CTV ad in under 5 minutes. Simply choose a template, paste your social media URL, and we handle the rest. Advanced customizations may take a bit longer."
              },
              {
                q: "What platforms can I run my ads on?",
                a: "Your VAST tag works with all major CTV platforms including Roku, Amazon Fire TV, Apple TV, Samsung TV Plus, LG Channels, and any ad server that supports VAST 4.2 (Google Ad Manager, The Trade Desk, etc.)."
              },
              {
                q: "Do I need video editing experience?",
                a: "Not at all! Our AI-powered platform handles all the technical aspects. You just need your social media content and we'll transform it into a stunning TV ad automatically."
              },
              {
                q: "Is there a free trial?",
                a: "Yes! Our free plan lets you create up to 3 videos per month. No credit card required. When you're ready for more, you can upgrade to Pro for unlimited videos and 4K quality."
              }
            ].map((faq, i) => (
              <div key={i} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100">
                <details className="group">
                  <summary className="flex items-center justify-between cursor-pointer list-none">
                    <h3 className="text-lg font-semibold text-gray-900">{faq.q}</h3>
                    <span className="transition-transform duration-300 group-open:rotate-180">
                      <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </span>
                  </summary>
                  <p className="mt-4 text-gray-600 leading-relaxed">{faq.a}</p>
                </details>
              </div>
            ))}
          </div>

          {/* Still have questions */}
          {/* <div className="text-center mt-12 p-8 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-3xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Still have questions?</h3>
              <p className="text-gray-600 mb-6">We're here to help you get started</p>
              <Link to="/contact" className="inline-flex items-center gap-2 bg-white text-gray-900 px-6 py-3 rounded-xl hover:bg-gray-50 transition-all shadow-md hover:shadow-lg font-medium">
                Contact Support
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div> */}
        </div>
      </section>


      {/* ================= FOOTER ================= */}
      <Footer />

    </div>
  );
}

/* ================= COMPONENTS ================= */

function SocialItem({ icon, label, color }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="flex flex-col items-center gap-2 cursor-pointer group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className={`h-16 w-16 flex items-center justify-center rounded-2xl bg-gradient-to-br ${color} group-hover:scale-110 group-hover:-translate-y-1 transition-all duration-300 shadow-lg group-hover:shadow-xl relative overflow-hidden`}
      >
        <div className={`absolute inset-0 bg-white/20 transform ${isHovered ? 'translate-x-full' : '-translate-x-full'} transition-transform duration-700`}></div>
        {React.cloneElement(icon, { className: "h-7 w-7 text-white relative z-10" })}
      </div>
      <span className="text-sm font-medium text-gray-600 group-hover:text-black transition">
        {label}
      </span>
    </div>
  );
}

function BrandPill({ name }) {
  return (
    <div className="px-6 py-3 bg-white border rounded-full shadow-sm hover:shadow-xl hover:-translate-y-1 hover:scale-105 transition-all duration-300 font-semibold text-gray-700 cursor-pointer relative overflow-hidden group">
      <span className="relative z-10">{name}</span>
      <div className="absolute inset-0 bg-gradient-to-r from-black/5 to-transparent transform -translate-x-full group-hover:translate-x-0 transition-transform"></div>
    </div>
  );
}

const StatCard = ({ number, label, trend, trendUp, color }) => {
  const colors = {
    blue: 'from-blue-500 to-indigo-500',
    orange: 'from-orange-500 to-red-500',
    green: 'from-green-500 to-emerald-500',
    purple: 'from-purple-500 to-pink-500'
  };

  const trendColor = trendUp
    ? "text-green-600 bg-green-100/60"
    : "text-red-600 bg-red-50";

  return (
    <div className="group bg-white rounded-2xl p-6 text-center border border-gray-200 hover:border-gray-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-default">
      <div className={`text-3xl font-bold bg-gradient-to-r ${colors[color]} bg-clip-text text-transparent mb-1`}>
        {number}
      </div>
      <div className="text-sm text-gray-500 mb-2">{label}</div>
      {/* <div className="inline-flex items-center gap-1 text-xs font-medium text-green-600 bg-green-50 px-2 py-0.5 rounded-full">
        <span>{trend}</span>
        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
        </svg>
      </div> */}

      {/* Trend */}
      {trend && (
        <div
          className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${trendColor}`}
        >
          <span>{trend}</span>

          {trend !== "Live" && (
            <svg
              className={`w-3 h-3 ${trendUp ? "" : "rotate-180"}`}
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z"
                clipRule="evenodd"
              />
            </svg>
          )}
        </div>
      )}
    </div>
  );
};
export function TikTokIcon({ size = 32, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.45095 19.7926C8.60723 18.4987 9.1379 17.7743 10.1379 17.0317C11.5688 16.0259 13.3561 16.5948 13.3561 16.5948V13.2197C13.7907 13.2085 14.2254 13.2343 14.6551 13.2966V17.6401C14.6551 17.6401 12.8683 17.0712 11.4375 18.0775C10.438 18.8196 9.90623 19.5446 9.7505 20.8385C9.74562 21.5411 9.87747 22.4595 10.4847 23.2536C10.3345 23.1766 10.1815 23.0889 10.0256 22.9905C8.68807 22.0923 8.44444 20.7449 8.45095 19.7926Z"
        fill="white"
      />
      <path
        d="M26.7009 9.91314V13.2472C26.7009 13.2472 25.1213 13.1853 23.9515 12.8879C22.3188 12.4718 21.2688 11.8337 21.2688 11.8337C21.2688 11.8337 20.5444 11.3787 20.4858 11.3464V20.1364C20.4858 20.6258 20.3518 21.8484 19.9432 22.8672C19.4098 24.2012 18.5867 25.0764 18.4353 25.2553C18.4353 25.2553 17.4337 26.4384 15.668 27.2352C14.0765 27.9539 12.6788 27.9357 12.2604 27.9539C12.2604 27.9539 9.84473 28.0496 7.66995 26.6366L7.6591 26.6288C7.42949 26.4064 7.21336 26.1717 7.01177 25.9257C6.31777 25.0795 5.89237 24.0789 5.78547 23.7934C5.78529 23.7922 5.78529 23.791 5.78547 23.7898C5.61347 23.2937 5.25209 22.1022 5.30147 20.9482C5.38883 18.9122 6.10507 17.6625 6.29444 17.3494C6.79597 16.4957 7.44828 15.7318 8.22233 15.0919C8.90538 14.5396 9.6796 14.1002 10.5132 13.7917C11.4144 13.4295 12.3794 13.2353 13.3565 13.2197V16.5948C13.3565 16.5948 11.5691 16.028 10.1388 17.0317C9.13879 17.7743 8.60812 18.4987 8.45185 19.7926C8.44534 20.7449 8.68897 22.0923 10.0254 22.991C10.1813 23.0898 10.3343 23.1775 10.4845 23.2541C10.7179 23.5576 11.0021 23.8221 11.3255 24.0368C12.631 24.8632 13.7249 24.9209 15.1238 24.3842C16.0565 24.0254 16.7586 23.2167 17.0842 22.3206C17.2888 21.7611 17.2861 21.1978 17.2861 20.6154V4.04639H20.5417C20.6763 4.81139 21.0485 5.90039 22.0328 6.97898C22.4276 7.38624 22.8724 7.7463 23.3573 8.05134C23.5006 8.19955 24.2331 8.93231 25.1734 9.38216C25.6596 9.61469 26.1722 9.79285 26.7009 9.91314Z"
        fill="white"
      />
    </svg>
  );
}